module.exports = __webpack_public_path__ + "static/media/medellin-5.29ad0ba7.jpg";